import { FirebaseApp, getApps, initializeApp } from 'firebase/app';
import { DataConnect, getDataConnect } from 'firebase/data-connect';
export { DataConnect } from 'firebase/data-connect';

export interface IConnectorConfig {
  location: string;
  connector: string;
  service: string;
}

export class DataConnectCache {
  private static _cache = new Map<string, DataConnect>();

  static getInstance(config: IConnectorConfig): DataConnect {
    const key = DataConnectCache._getKey(config);
    const cached = DataConnectCache._cache.get(key);
    if (cached) {
      return cached;
    }

    const app = DataConnectCache._resolveApp();
    const instance = getDataConnect(app, config);
    DataConnectCache._cache.set(key, instance);
    return instance;
  }

  private static _resolveApp(): FirebaseApp {
    const existing = getApps().find((app) => app && app.name === '[DEFAULT]');
    return existing ?? initializeApp();
  }

  private static _getKey(config: IConnectorConfig): string {
    return `${config.service}-${config.location}-${config.connector}`;
  }
}

// eslint-disable-next-line @typescript-eslint/require-await
export async function dataConnect(
  config: IConnectorConfig
): Promise<DataConnect> {
  return DataConnectCache.getInstance(config);
}
